import * as moment from 'moment';
import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { IPackageListingState, IPerformanceSeatStatus } from '../classes/package-listing';
import { IPackageListingAppText } from '../custom/classes/package-listing-text';
import packageListingTextReducer from './reducers/package-text.reducer';
import packageListingReducer from './reducers/package-listing.reducer';
import { IProduction, IPackage } from '../custom/classes/production';
import { loadPackage, updateSettings, loadPackages, loadPackageRequest, selectPackage, updatePerformanceSeatStatuses } from './actions/package-listing.actions';
import { IPackageListingAppSettings } from '../custom/classes/package-listing-settings';
import packageListingSettingsReducer from './reducers/package-settings.reducer';
import { getPackagePerformances } from '../helpers/package-helper';


declare const pageData: any;
declare const packageDetail: any;
declare const packages: Array<IPackage>;
declare const packageRequest: any;
declare const performanceSeatStatuses: Array<IPerformanceSeatStatus>;

export interface IPackageListingAppState {
    packageListing: IPackageListingState<IPackage>;
    packageListingText: IPackageListingAppText;
    packageListingSettings: IPackageListingAppSettings;
}

const appReducer = combineReducers({
    packageListing: packageListingReducer,
    packageListingText: packageListingTextReducer,
    packageListingSettings: packageListingSettingsReducer
});

//let calendarSettings = {
//    ...defaultCalendarSettings
//};

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const appStore = createStore(appReducer, {
    //calendarSettings: calendarSettings
}, composeEnhancers(applyMiddleware(thunk)));

// redux-thunk messes with redux typings.
//appStore.dispatch(getEventsFromApi() as any);


appStore.dispatch(updateSettings(pageData) as any);
if (typeof (packageDetail) === "undefined") {
    appStore.dispatch(loadPackages(packages));

    var packagesWithPerfs = packages.filter(p => getPackagePerformances(p).length > 0);

    if (packagesWithPerfs.length == 1) {
        var select = selectPackage((packagesWithPerfs[0]));
        appStore.dispatch(select as any);

    }
    if (packageRequest) {
        appStore.dispatch(loadPackageRequest(packageRequest) as any);
    }
} else {
    appStore.dispatch(loadPackage(packageDetail));
}

appStore.dispatch(updatePerformanceSeatStatuses(performanceSeatStatuses) as any);

export { appStore };
